(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["description-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.custom-tab');
  const tabContents = document.querySelectorAll('.custom__tab-content');
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      const contentId = this.dataset.contentId;
      const content = document.getElementById(contentId);
      tabContents.forEach(function(content) {
        content.classList.remove('active');
      });
      tabs.forEach(function(tab) {
        tab.closest('li').classList.remove('active');
      });
      this.closest('li').classList.add('active');
      if (content) content.classList.add('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
